// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqMyQuotesFilterStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { GridItemStyle } from "@insite/mobius/GridItem";
import myAccountFilterSectionStyles from "@tps/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

rfqMyQuotesFilterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            padding: 10px 15px;
            ${GridItemStyle} {
                padding: 10px;
            }
        `,
    }),
};

rfqMyQuotesFilterStyles.headingItem = {
    css: css`
        display: none;
    `,
};

rfqMyQuotesFilterStyles.fromGridItem =
    rfqMyQuotesFilterStyles.toGridItem =
    rfqMyQuotesFilterStyles.expireFromGridItem =
    rfqMyQuotesFilterStyles.expireToGridItem =
        {
            ...myAccountFilterSectionStyles.smallGridItem,
        };

rfqMyQuotesFilterStyles.quoteNumberGridItem = {
    width: [12, 12, 6, 3, 4],
};

rfqMyQuotesFilterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

rfqMyQuotesFilterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,

};

rfqMyQuotesFilterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};

rfqMyQuotesFilterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

rfqMyQuotesFilterStyles.customerGridItem = {
    width: [12, 12, 6, 3, 4],
};

rfqMyQuotesFilterStyles.expireFromDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
        datePicker: css`
            .react-calendar {
                right: 0;
                left: unset;
            }
        `,
    },
};

rfqMyQuotesFilterStyles.expireToDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
        datePicker: css`
            .react-calendar {
                right: 0;
                left: unset;
            }
        `,
    },
};

rfqMyQuotesFilterStyles.salesRepGridItem = {
    width: [12, 12, 6, 3, 4],
};

rfqMyQuotesFilterStyles.userGridItem = {
    width: [12, 12, 6, 3, 4],
};
